module.exports = __webpack_public_path__ + "img/10.52e14430.jpg";